import React, {useRef, useState} from 'react';
import { connect } from 'react-redux';
import {withStyles, Tooltip, IconButton, Typography} from '@material-ui/core';
import {Devices, FindInPage, GroupRounded} from '@material-ui/icons';
import { Redirect } from 'react-router-dom';
import { hasPermission, createHistory, hasAtLeastOnePermission } from '../../sc-utilities';
import GroupList from "./GroupList";
import { getBalance } from '../../sc-users/User';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    }
});

const Group = props => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions } = props;

    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, id: null, redirectPath: '' });
    const redirectHandler = (path, id = null) => {
        createHistory();
        setRedirectOptions({ redirect: true, id: id, redirectPath: path })
    };

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    const visible = columns && columns['Group'];
    let tableColumns = [
        {
            title: translations["action"] || "Action", field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            filtering: false,
            render: rowData => <>
                {
                    hasPermission(permissions, 'group_load') &&
                    <Tooltip title={translations["group_details"] || "Group details"}>
                        <IconButton
                            id={`edit_group_${rowData.GroupID}`}
                            component='div'
                            onClick={() => redirectHandler(`/settings/group/edit?GroupID=${rowData.GroupID}`)}
                        >
                            <FindInPage />
                        </IconButton>
                    </Tooltip>
                }
                {
                    hasPermission(permissions, 'all_assets_view') &&
                    <Tooltip title={translations["group_products"] || "Group products"}>
                        <IconButton
                            id={`group_products_${rowData.GroupID}`}
                            component='div'
                            onClick={() => redirectHandler(`/products/all-assets?GroupID=${rowData.GroupID}`)}
                        >
                            <Devices />
                        </IconButton>
                    </Tooltip>
                }
                {
                    hasPermission(permissions, 'user_list') &&
                    <Tooltip title={translations["group_users"] || "Group users"}>
                        <IconButton
                            id={`group_users_${rowData.GroupID}`}
                            component='div'
                            onClick={() => redirectHandler(`/account-management/users?GroupID=${rowData.GroupID}`)}
                        >
                            <GroupRounded />
                        </IconButton>
                    </Tooltip>
                }
            </>
        },
        {
            title: translations["name"] || 'Name', field: 'Name',
            hidden: visible ? visible['Name'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Name ? rowData.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["parent_name"] || 'Parent name', field: 'ParentName',
            hidden: visible ? visible['ParentName'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData?.Parent?.Name ? rowData?.Parent?.Name : translations['parent_name_not_assigned_root'] || 'n/a (root)'}</Typography>;
            }
        },
        {
            title: translations["balance"] || 'Balance', field: 'Balance',
            hidden: visible ? visible['Balance'] : false,
            filtering: false,
            render: rowData => {
                return <Typography style={{ fontSize: 12 }} gutterBottom>{getBalance(rowData.Balances, translations)}</Typography>
        }}
    ];

    if (!hasAtLeastOnePermission(permissions, ['group_load', 'all_assets_view', 'user_list'])) {
        tableColumns.shift();
    }

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'group_list') &&
                <GroupList
                    tableColumns={tableColumns}
                    redirectHandler={redirectHandler}
                    tableRef={tableRef}
                />}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(Group));